import { FavoriteButtonWrapperContainer } from '@cian/favorites-assign-widget';
import { IconButton } from '@cian/ui-kit';
import { IconToggleHeartOn24, IconToggleHeartOff24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { changeLayoutFavorite } from 'shared/actions/favoriteLayout';

import { Dispatch } from '../../common/state';
import { isAuthenticatedUserSelector } from '../../selectors/isAuthenticatedUserSelector';
import { residentialComplexLayoutByOfferIdSelector } from '../../selectors/newbuildingLayouts';
import { INewbuildingLayoutOffer } from '../../types/residentialComplexLayouts/layoutWithOffers/offer';

export interface IFavoritesControlContainerProps {
  offerId: number;
}
export function FavoritesControlContainer({ offerId }: IFavoritesControlContainerProps) {
  const dispatch: Dispatch = useDispatch();
  const offer = useSelector(residentialComplexLayoutByOfferIdSelector)(offerId) as INewbuildingLayoutOffer;
  const isAuthenticated = useSelector(isAuthenticatedUserSelector);

  const [isFavorite, setFavorite] = React.useState(Boolean(offer.isFavorite));

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    dispatch(changeLayoutFavorite(offerId, !isFavorite));
    setFavorite(!isFavorite);
  };

  const handleLogin = React.useCallback(() => {
    if (window.waitForLoginPopup) {
      window.waitForLoginPopup('favorites');
    }
  }, []);

  const button = (
    <IconButton
      data-mark="FavoritesControl"
      onClick={handleClick}
      color={isFavorite ? 'icon-negative-default' : 'icon-secondary-default'}
      icon={
        isFavorite ? (
          <div>
            <IconToggleHeartOn24 color="icon-negative-default" />
          </div>
        ) : (
          <div>
            <IconToggleHeartOff24 />
          </div>
        )
      }
    />
  );

  if (!offer) {
    return null;
  }

  return (
    <FavoriteButtonWrapperContainer
      offerId={offer.offerId}
      placement="bottom-end"
      isAuthenticated={isAuthenticated}
      onWaitForLogin={handleLogin}
    >
      {button}
    </FavoriteButtonWrapperContainer>
  );
}
